import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ctaCopy, DOWNLOAD_LINK, HEADLINE_LINK } from '../../data/landingData';
import { fadeInUp } from '../../utils/motion';
import { Button } from '../ui/Button';

export function FinalCtaSection() {
  return (
    <section id="contacto" className="bg-white py-16 sm:py-20">
      <div className="container-base">
        <motion.div
          className="rounded-[2rem] border border-slate-100 bg-gradient-to-br from-brand-50 to-white px-6 py-10 text-center shadow-soft sm:px-10 sm:py-14"
          variants={fadeInUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.45 }}
        >
          <h2 className="font-display text-3xl font-bold leading-tight text-ink sm:text-4xl">{ctaCopy.title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">{ctaCopy.subtitle}</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button href={DOWNLOAD_LINK} target="_blank" rel="noreferrer">
              {ctaCopy.button}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button href={HEADLINE_LINK} target="_blank" rel="noreferrer" variant="outline">
              Más información
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
